import React from 'react'
import { RadBox } from '../common/RadBox'
import { RadButton } from '../common/RadButton'
import { RadContainer } from '../common/RadContainer'
import { RadCopyToClipboard } from '../common/RadCopyToClipboard'
import { RadGrid } from '../common/RadGrid'
import { RadLink } from '../common/RadLink'
import { RadSpaceBetween } from '../common/RadSpaceBetween'

export function CollaborativeDetailContent ({ collaborative, setSelectedEntity }) {
  if (collaborative == null) {
    return null
  }

  return (
    <RadSpaceBetween size='l'>

      <div>
        <RadBox variant='awsui-key-label' display='inline'>
          SECTOR(S):
        </RadBox>
        <RadBox variant='span' padding={{ left: 'xs' }}>
          {collaborative.sectors.map(x => x.sector?.name ?? x.name).join(', ') || '-'}
        </RadBox>
      </div>

      <RadGrid
        gridDefinition={[
          { colspan: { default: 12, xs: 8 } },
          { colspan: { default: 12, xs: 4 } }
        ]}
      >
        <RadSpaceBetween size='s'>
          <RadBox>{collaborative.description}</RadBox>

          <br />

          <RadCopyToClipboard
            copyButtonText='Copy link'
            copyErrorText='Link failed to copy'
            copySuccessText='Link copied'
            textToCopy={`${window.location.origin}/collaborative/${collaborative.id}`}
          />
        </RadSpaceBetween>

        <RadContainer className='gray-background'>
          <RadSpaceBetween size='s'>
            <RadBox variant='h3'>
              Collaborative Details
            </RadBox>

            <div>
              <RadBox variant='awsui-key-label'>
                Website
              </RadBox>
              <div>{collaborative.website != null ? <RadLink href={collaborative.website}>{collaborative.website}</RadLink> : '-'}</div>
            </div>

            <div>
              <RadBox variant='awsui-key-label'>
                Goal
              </RadBox>
              <div>{collaborative.goal ?? '-'}</div>
            </div>

            {
              collaborative.contacts != null &&
                <div>
                  <RadBox variant='awsui-key-label'>
                    Contacts
                  </RadBox>
                  <div>{collaborative.contacts.length > 0
                    ? collaborative.contacts.map((x) => <div key={x.id}>{x.name}</div>)
                    : '-'}
                  </div>
                </div>
            }

            <div>
              <RadBox variant='awsui-key-label'>
                Organizations
              </RadBox>
              <div>{collaborative.organizations?.length > 0
                ? collaborative.organizations.map((x) =>
                  <div key={x.id}>
                    {setSelectedEntity == null && <RadLink href={`/organization/${x.organization.id}`}>{x.organization?.name}</RadLink>}
                    {setSelectedEntity != null &&
                      <RadButton
                        onClick={() => setSelectedEntity({ type: 'organization', id: x.organization.id })}
                        className='font-weight-400'
                        variant='inline-link'
                      >
                        {x.organization?.name}
                      </RadButton>}
                  </div>
                )
                : '-'}
              </div>
            </div>

            <div>
              <RadBox variant='awsui-key-label'>
                Projects
              </RadBox>
              <div>{collaborative.projects?.length > 0
                ? collaborative.projects.map((x) =>
                  <div key={x.id}>
                    {setSelectedEntity == null && <RadLink href={`/project/${x.project.id}`}>{x.project?.name}</RadLink>}
                    {setSelectedEntity != null &&
                      <RadButton
                        onClick={() => setSelectedEntity({ type: 'project', id: x.project.id })}
                        className='font-weight-400'
                        variant='inline-link'
                      >
                        {x.project?.name}
                      </RadButton>}
                  </div>
                )
                : '-'}
              </div>
            </div>

            <div>
              <RadBox variant='awsui-key-label'>
                Framework Tags
              </RadBox>
              <div>
                {collaborative.tags?.length > 0 ? collaborative.tags.map((x) => x.tag.name).join(', ') : '-'}
              </div>
            </div>

            <div>
              <RadBox variant='awsui-key-label'>
                Priority Areas
              </RadBox>
              <div>{collaborative.targetAreas?.length > 0 ? collaborative.targetAreas.map((x) => <div key={x.id}>{x.targetArea?.name}</div>) : '-'}</div>
            </div>
          </RadSpaceBetween>
        </RadContainer>
      </RadGrid>
    </RadSpaceBetween>
  )
}
